import * as Sentry from "@sentry/angular";
import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import de_DE from '@angular/common/locales/de'
import en_GB from '@angular/common/locales/en-GB'
import en_US from '@angular/common/locales/en'
import {registerLocaleData} from '@angular/common';
import { environment } from './environments/environment';

registerLocaleData(de_DE, 'de-DE');
registerLocaleData(en_GB, 'en-GB');
registerLocaleData(en_US, 'en-US');
// console.log('Sentry env:', environment.sentryEnvironment);
Sentry.init({
    dsn: "https://f9a8100cfaae8654c164231d7030db0a@sentry.head.com/41",
    release: environment.sentryRelease,
    environment: environment.sentryEnvironment,
    ignoreErrors: [/^unauthorized$/]
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
